import React, { useEffect, useState } from 'react';
import './index.scss';
import { Button, Modal, Col, Row, Typography, notification, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
    DeleteOutlined,
    ExclamationCircleOutlined,
    EyeFilled,
    EditFilled, UnlockFilled, LockFilled, CheckCircleTwoTone, CloseCircleFilled,
} from '@ant-design/icons';
import Parameters from 'shared/parameters';

import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import { AuthConsumer } from 'shared/contexts/AuthContext';
import { DATE_FORMAT_LONG } from 'shared/constants/AppConstants';
import enrolledImg from '../../../src/img/img-enrolled.jpg';
import starGolden from '../../../src/img/star-golden.png';
import starBlue from '../../../src/img/star-blue.png';
import plusIcon from '../../../src/img/plus.png';
import filterIcon from '../../../src/img/filter.png';
import switchtick from '../../../src/img/switch-tick.png';
import arrowLeft from '../../../src/img/arrow-left.png';

interface Props {
    location: any;
}

const { Title, Link } = Typography;
const { confirm } = Modal;
export default function CoursesPage() {
    const { t } = useTranslation();
    const history: any = useHistory();

    const [deletingItem, setDeletingItem] = useState(false);
    const [items, setItems] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    const [lang, setLang] = useState('' as any);
    const columns = [
        {
            title: t('genDict.title'),
            key: 'title',
            dataIndex: 'title',
        },
        {
            title: t('genDict.category'),
            key: 'category',
            dataIndex: ['category', 'name'],
        },
        {
            title: t('genDict.level'),
            key: 'level',
            dataIndex: ['level', 'name'],
        },
        {
            title: t('genDict.author'),
            key: 'author',
            dataIndex: ['author', 'name'],
        },
        {
            title: t('genDict.isFeatured'),
            key: 'isFeatured',
            dataIndex: 'is_featured',
            render: (a: number) => a ? <CheckCircleTwoTone/> : <CloseCircleFilled/>,
        },
        {
            title: t('genDict.isPopular'),
            key: 'isPopular',
            dataIndex: 'is_popular',
            render: (a: number) => a ? <CheckCircleTwoTone/> : <CloseCircleFilled/>,
        },
        {
            title: t('genDict.status'),
            key: 'status',
            dataIndex: 'status',
        },
        {
            title: t('genDict.createdAt'),
            key: 'created_at',
            dataIndex: 'created_at',
            render: (a: number) => moment(a).format(DATE_FORMAT_LONG),
        },
        {
            title: t('genDict.action'),
            key: 'action',
            render: (a: any) => {
                return <Space>
                    {
                        a.status === 'INACTIVE' ? <Button shape={'circle'} danger type={'primary'}  onClick={() => {
                                API_SERVICE.activateCourse(a.id).then(() => {
                                    refreshItems();
                                }).catch((e) => {
                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                });
                            }
                            } icon={<LockFilled/>}/> :
                            <Button shape={'circle'}  type={'primary'} onClick={() => {
                                API_SERVICE.deactivateCourse(a.id).then(() => {
                                    refreshItems();
                                }).catch((e) => {
                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                });
                            }
                            } className={'success-button '} icon={<UnlockFilled/>}/>
                    }
                    <Button type="default" shape="circle" icon={<EyeFilled/>}
                            onClick={() => {
                                history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${a.id}/view`);
                            }}/>
                    <Button type="default" shape="circle" icon={<EditFilled/>}
                            onClick={() => {
                                history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${a.id}/edit`);
                            }}/>
                    <Button type="primary" danger={true} shape="circle" icon={<DeleteOutlined/>}
                            onClick={() => confirm({
                                icon: <ExclamationCircleOutlined/>,
                                title: t('genDict.confirmDelete'),
                                okText: t('genDict.ok'),
                                cancelText: t('genDict.cancel'),
                                content: `${t('genDict.confirmDelete')} "${a.name}"`,
                                okButtonProps: { loading: deletingItem, danger: true },
                                onOk: async () => {
                                    setDeletingItem(true);
                                    API_SERVICE.removeCourse(a.id).then((d) => {
                                        notification.success({
                                            message: t('genDict.success'),
                                        });
                                        refreshItems();
                                    }).catch((e: any) => {
                                        notification.error({
                                            message: t(API_SERVICE.handleErrors(e)),
                                        });
                                    }).finally(() => {
                                        setDeletingItem(false);
                                    });
                                },
                            })
                            }/>
                </Space>;
            },
        },
    ];
    const refreshItems = async () => {
      
        try {
            setFetching(true);
            const params: any = { order_by: 'id', page: 1,per_page: 'all', order: 'DESC' }
            const {
                data: {
                    data: {
                        count,
                        current_page,
                        items,
                        per_page,
                        total,
                    },
                },
            } = await API_SERVICE.fetchCoursesAdmin(params);
            setItems(items);
            console.log('itemsss', items)
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    useEffect(() => {
        refreshItems();
        setLang(localStorage.getItem('language'));
    }, []);
    return (
        <AuthConsumer>
            {({ isAuth }) =>
                !isAuth ? (
                    history.push('/login')
                ) : (
                    <div>
                        <div className="container-fluid">
                            <div className={'d-flex justify-space-between'}>
                                <div className={lang == 'ar' ? 'mt-3' : 'mt-3'}>
                                    <h3><span className='back-bg mr-4 cursor-pointer'><img src={arrowLeft} className="page-back" /></span> {t('genDict.courses')}</h3>    
                                </div>
                                <div className={lang == 'ar' ? 'mr-2 text-sm-right mt-3' : 'text-sm-right mt-3'}>
                                    
                                    <Button className='btn btn-blue' onClick={() => history.push(`courses/create`)}>
                                        {
                                            // <span className='d-flex align-items-center'><img src={plusIcon} className="mr-1"/>{t('genDict.add') +' Course'}</span>
                                            <span className='d-flex align-items-center'><img src={plusIcon} className={lang == 'ar' ? 'ml-2' : 'mr-1'}/>{t('genDict.AddCourse')}</span>
                                        }
                                    </Button>    
                                </div>
                            </div>
                        </div>
                    
                        <div className="container-fluid">
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='bg-white p-3 br-5px'>    
                                        <div className='row'>
                                            <div className='col-lg-12 mb-4'>
                                                {/* <h4 className='float-left'>Marketing (4)</h4> */}
                                                <div className={lang === 'ar' ? 'pl-3 pr-3 float-right d-flex align-items-center' : 'float-right d-flex align-items-center'} style={{flexWrap:'nowrap'}}>
                                                    <span className={lang === 'ar' ? 'mr-2' : 'mr-2'} style={{whiteSpace:'nowrap'}}>{t('genDict.SearchCourse')}</span>  
                                                    <input type='text' name="course-search" id="course-search" placeholder={t('genDict.EnterCourseTitle')} className={lang == 'ar' ? 'form-control mr-2' : 'form-control'}/>
                                                </div>
                                            </div>
                                            { items && items.map((item:any,index: any) => {
                                                return <><div className='col-lg-12 mb-4'>
                                                        <h4 className={lang === 'ar' ? 'text-right pr-3 pl-3' : 'float-left'}>{item.name} ({item.course.length})</h4>
                                                        <div className='float-right d-flex align-items-center' style={{ flexWrap: 'nowrap' }}>
                                                            
                                                        </div>
                                                    </div>
                                                    {item.course && item.course.map((courseItem:any,cIndex:any) => {
                                                        return <div className='col-lg-4 mb-4'>
                                                        <div className='pl-3 pr-3'>
                                                            <div className='shadow br-5px'>
                                                                <div className='pos-relative'>

                                                                    <img src={Parameters.ImageBaseUrl + courseItem.thumbnail.slug + courseItem.thumbnail.ext}
                                                                    className="img-fluid w-100 cursor-pointer" style={{height:'185px',objectFit:'cover'}}
                                                                    onClick={() => {
                                                                        history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${courseItem.id}/view`);
                                                                    }}/>
                                                                    <div className='bottom-right'>
                                                                        <Button type="default" shape="circle" icon={<EditFilled />}
                                                                            onClick={() => {
                                                                                history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${courseItem.id}/edit`);
                                                                            } } />
                                                                    </div>
                                                                    <div className='top-right'>
                                                                    {courseItem.is_popular ?<span className="labeled recommend small d-flex align-items-center"><img src={starGolden} style={{width:'13px'}}/>&nbsp;Popular</span> : ''}   
                                                                        {courseItem.is_featured ? <span className="labeled featured small d-flex align-items-center"><img src={starBlue} style={{ width: '13px' }} />&nbsp;Featured</span>: ''}
                                                                    </div>
                                                                    <div className='bottom-left'>
                                                                        <Button type="primary" danger={true} shape="circle" icon={<DeleteOutlined />}
                                                                            onClick={() => confirm({
                                                                                icon: <ExclamationCircleOutlined />,
                                                                                title: t('genDict.confirmDelete'),
                                                                                okText: t('genDict.ok'),
                                                                                cancelText: t('genDict.cancel'),
                                                                                content: `${t('genDict.confirmDelete')} "${courseItem.title}"`,
                                                                                okButtonProps: { loading: deletingItem, danger: true },
                                                                                onOk: async () => {
                                                                                    setDeletingItem(true);
                                                                                    API_SERVICE.removeCourse(courseItem.id).then((d) => {
                                                                                        notification.success({
                                                                                            message: t('genDict.success'),
                                                                                        });
                                                                                        refreshItems();
                                                                                    }).catch((e: any) => {
                                                                                        notification.error({
                                                                                            message: t(API_SERVICE.handleErrors(e)),
                                                                                        });
                                                                                    }).finally(() => {
                                                                                        setDeletingItem(false);
                                                                                    });
                                                                                },
                                                                            })} />
                                                                    </div>
                                                                    <div className='top-left'>
                                                                    {courseItem?.level?.name && <span className="labeled featured small d-flex align-items-center" style={{padding: '0px 10px'}}>{courseItem.level.name}</span>} 
                                                                    </div>
                                                                </div>
                                                                <div className='p-2'>
                                                                    {/* {console.log('itemmm', item)} */}
                                                                    <h5 className=''>{courseItem.title}</h5>
                                                                    <p className='small text-secondary mb-1'>
                                                                        <span>by {courseItem.author.name}</span>
                                                                        
                                                                        {    courseItem.status === 'INACTIVE' ? <span className='float-right btn-switch' onClick={() => {
                                                                                    API_SERVICE.activateCourse(courseItem.id).then(() => {
                                                                                        refreshItems();
                                                                                    }).catch((e) => {
                                                                                        notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                                    });
                                                                                }
                                                                                }>
                                                                                <input type="checkbox" id={`checkbox${courseItem.id}`} disabled />
                                                                                <label htmlFor={`checkbox${courseItem.id}`}></label>
                                                                            </span> :
                                                                            <span className='float-right btn-switch' onClick={() => {
                                                                                    API_SERVICE.deactivateCourse(courseItem.id).then(() => {
                                                                                        refreshItems();
                                                                                    }).catch((e) => {
                                                                                        notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                                    });
                                                                                }
                                                                                }>
                                                                                <input type="checkbox" id={`checkbox${courseItem.id}`} checked disabled />
                                                                                <label htmlFor={`checkbox${courseItem.id}`}></label>
                                                                            </span>
                                                                        }
                                                                    </p>
                                                                    <p className='small mb-1 text-4f46e5'>{t('genDict.Enrolled')}</p>
                                                                    <div className=''>
                                                                        <ul className='list-style-none d-flex align-items-center' style={{ flexWrap: 'nowrap' }}>
                                                                        {courseItem.course_users && courseItem.course_users.slice(0,5).map((courseUser:any,sIndex:any) => {
                                                                            
                                                                            return <>
                                                                            {courseUser.avatar_image ?
                                                                                <li className='li-enrolled-img'>
                                                                                    <img src={Parameters.ImageBaseUrl + courseUser.avatar_image.slug + courseUser.avatar_image.ext} className='img-enrolled' />
                                                                                </li>
                                                                            : <li className='li-enrolled-img'>
                                                                                    <img src={Parameters.ImageBaseUrl + 'avatar.png'} className='img-enrolled' />
                                                                                </li>
                                                                            }
                                                                            </>
                                                                        })}
                                                                        {courseItem.course_users.length <= 0 ?
                                                                            
                                                                            <><li className='small text-4f46e5 ml-2'> + {0}</li></>
                                                                        :
                                                                            ''
                                                                        }
                                                                            {courseItem.course_users.length > 5 ?
                                                                            <li className='small text-4f46e5 ml-2'> + {courseItem.course_users.length - 5}</li>
                                                                            :''
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                    <div className='mt-2'>
                                                                        <ul className='list-style-none d-flex justify-content-space-between'>
                                                                            <li className='text-center small text-secondary'>
                                                                                <span>{t('genDict.Module')}</span><br></br>
                                                                                <span>{courseItem.curriculums.length}</span>
                                                                            </li>
                                                                            <li className='text-center small text-secondary'>
                                                                                <span>{t('genDict.Lectures')}</span><br></br>
                                                                                <span>{courseItem.lectures_count}</span>
                                                                            </li>
                                                                            <li className='text-center small text-secondary'>
                                                                                <span>{t('genDict.Assignment')}</span><br></br>
                                                                                <span>{courseItem.assignments_count}</span>
                                                                            </li>
                                                                            {/* <li className='text-center small text-secondary'>
                                                                                <span>Duration</span><br></br>
                                                                                <span>{Math.round((courseItem.duration_in_minutes)/60)}h</span>
                                                                            </li> */}
                                                                        </ul>
                                                                    </div>

                                                                    {/* <Button type="default" shape="circle" icon={<EyeFilled/>}
                        onClick={() => {
                            history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${item.id}/view`);
                        }}/> */}
                                                                    {/* <Button type="default" shape="circle" icon={<EditFilled/>}
                        onClick={() => {
                            history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${item.id}/edit`);
                        }}/> */}
                                                                    {/* <Button type="primary" danger={true} shape="circle" icon={<DeleteOutlined/>}
                        onClick={() => confirm({
                            icon: <ExclamationCircleOutlined/>,
                            title: t('genDict.confirmDelete'),
                            okText: t('genDict.ok'),
                            cancelText: t('genDict.cancel'),
                            content: `${t('genDict.confirmDelete')} "${item.name}"`,
                            okButtonProps: { loading: deletingItem, danger: true },
                            onOk: async () => {
                                setDeletingItem(true);
                                API_SERVICE.removeCourse(item.id).then((d) => {
                                    notification.success({
                                        message: t('genDict.success'),
                                    });
                                    refreshItems();
                                }).catch((e: any) => {
                                    notification.error({
                                        message: t(API_SERVICE.handleErrors(e)),
                                    });
                                }).finally(() => {
                                    setDeletingItem(false);
                                });
                            },
                        })
                        }/> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    })}
                                                </>
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
         </AuthConsumer>
    );
}
